import { BaseResponse } from './internal/baseresponse';
export class TransactionCheckAMLResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/transactioncheckamlresult.ts